import { isFabricationExecutionScope } from './executionScope';

export type ExecutionDisplayInfo = {
  scopeLabel: string;
  modeLabel: string;
  completionLabel: string;
  deliveryLabel: string;
  procurementLabel?: string;
  partialDeliveryAllowed: boolean;
  tooltip: string;
  procurementTooltip?: string;
  badgeColor: 'fabrication' | 'neutral';
};

const PROCUREMENT_RULE_FABRICATION =
  'One PR per outsourced BOQ operation (total BOQ line quantity on the PR, not per production unit).';

function normalizeScope(scope?: string | null): string {
  const s = String(scope ?? '').trim();
  return s || '—';
}

/**
 * Display labels for execution_scope (UI badges + print). Does not affect business logic.
 */
export function getExecutionDisplayInfo(executionScope?: string | null): ExecutionDisplayInfo {
  const scopeLabel = normalizeScope(executionScope);

  if (isFabricationExecutionScope(executionScope)) {
    return {
      scopeLabel: 'Fabrication',
      modeLabel: 'Unit-wise',
      completionLabel: 'Partial completion allowed',
      deliveryLabel: 'Partial delivery allowed',
      procurementLabel: 'One PR per outsourced BOQ operation',
      partialDeliveryAllowed: true,
      tooltip:
        'Operations, inspections, progress, and delivery are executed unit-wise.',
      procurementTooltip: PROCUREMENT_RULE_FABRICATION,
      badgeColor: 'fabrication',
    };
  }

  if (!scopeLabel || scopeLabel === '—') {
    return {
      scopeLabel: '—',
      modeLabel: '—',
      completionLabel: '—',
      deliveryLabel: '—',
      partialDeliveryAllowed: false,
      tooltip: 'Execution scope is not set on this work order.',
      badgeColor: 'neutral',
    };
  }

  return {
    scopeLabel,
    modeLabel: 'BOQ-line-wise',
    completionLabel: 'Partial completion not allowed',
    deliveryLabel: 'Partial delivery not allowed',
    partialDeliveryAllowed: false,
    tooltip: 'Operations execute using total BOQ line quantity.',
    badgeColor: 'neutral',
  };
}
